export const PLAYLIST_TYPE_MAP = {
	1: 'Live',
	2: 'VoD',
};

export const PLAYLIST_TYPE = {
	LIVE: 1,
	VOD: 2,
};
